<script setup lang="ts">
const { MENUS } = useNavigation()

const navs = [
  [
    {
      label: 'Layanan',
      child: [
        ...(
          MENUS.find((menu) => menu.key === 'layanan')
            ?.child?.filter((child) => child.group !== 'Keunggulan')
            .map((child) => [...child.items]) || []
        ).flat()
      ]
    },
    {
      label: 'Solusi',
      child: [
        ...(
          MENUS.find((menu) => menu.key === 'solusi')?.child?.map((child) => [
            ...child.items
          ]) || []
        ).flat()
      ]
    }
  ],
  [
    {
      label: 'Keunggulan',
      child: [
        ...(MENUS.find((menu) => menu.key === 'layanan')?.child?.find(
          (child) => child.group === 'Keunggulan'
        )?.items || [])
      ]
    }
  ],
  [
    {
      label: 'Lainnya',
      child: [
        ...MENUS.filter((menu) =>
          ['cek-ongkir', 'cek-resi', 'panduan', 'pengaduan'].includes(menu.key)
        )
      ]
    },
    {
      label: 'Perusahaan',
      child: [
        ...(
          MENUS.find((menu) => menu.key === 'perusahaan')?.child?.map(
            (child) => [...child.items]
          ) || []
        ).flat()
      ]
    }
  ]
]
</script>
<template>
  <div
    v-for="(groups, i1) in navs"
    :key="i1"
    class="flex flex-col col-span-2 gap-2 md:col-span-1"
  >
    <div v-for="(group, i2) in groups" :key="i2">
      <div>
        <div class="mb-1.5 font-semibold text-primary">{{ group.label }}</div>
        <ul>
          <li v-for="(item, i) in group.child" :key="i">
            <NuxtLink
              :to="item.to || '#'"
              class="block py-1.5 hover:text-primary"
              :external="item.external"
              :target="item.target"
              :rel="item.rel"
            >
              <span>{{ item.title }}</span>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
